import React from "react";
import { useNavigate } from "react-router";
import CustomButton from "../../components/form/CustomButton";
import { currencyUSD } from "../../helpers/forms/formater";
import CustomSelect from "../../components/form/CustomSelect";
import {
    changeStatusServiceOrder,
    servicesOrderResource
} from "../../helpers/configRoutes/backend_helper";

export const Columns = (
    openModalAdd,
    setModalConfirm,
    modalConfirm,
    modalFiles,
    setModalFiles,
    statuses,
    setFilters,
    filters,
    setModalPdf
) => {
    const navigate = useNavigate();

    const changeStatus = async (item, status) => {
        await changeStatusServiceOrder({ id: item.id, status_id: status });
        setFilters({ ...filters });
    };

    const getPdfDetailFile = async (id, email = "") => {
        const response = await servicesOrderResource(
            "show",
            { params: { pdf: true, sendEmail: email } },
            id
        );

        if (!email) {
            setModalPdf({ show: true, url: response.pdf });
        }
    };

    const iconBtn =
        "flex items-center justify-center w-9 h-9 rounded-md hover:bg-gray-100 transition";

    let columns = [
        {
            id: "no_service",
            name: "ID SERVICE ORDER",
            selector: row => row.internalId
        },
        {
            id: "supplier",
            name: "SUPPLIER",
            selector: row => row.supplier?.name
        },
        {
            id: "estimated_cost",
            name: "ESTIMATED COST",
            selector: row => currencyUSD(row.estimated_cost)
        },
        {
            id: "creation_date",
            name: "CREATED DATE",
            selector: row => row.creation_date
        },
        {
            id: "due_date",
            name: "DUE DATE",
            selector: row => row.due_date
        },
        {
            id: "trailer",
            name: "Trailer",
            selector: row => row.trailer?.name
        },
        {
            id: "truck",
            name: "Truck",
            selector: row => row.truck?.name
        },
        {
            id: "evidences",
            name: "EVIDENCES",
            cell: row => (
                <CustomButton
                    type="button"
                    onClick={() =>
                        setModalFiles({ ...modalFiles, show: true, item: row })
                    }
                    className="w-full rounded-full bg-teal-100 text-teal-700 hover:bg-teal-200 py-2 text-sm font-medium"
                >
                    Files
                </CustomButton>
            )
        },
        {
            id: "status",
            name: "STATUS",
            cell: row => (
                <CustomSelect
                    options={statuses}
                    name="status_id"
                    value={row.status_id}
                    handleChange={e => changeStatus(row, e.target.value)}
                    colorOption={row.status?.color}
                    className="w-full bg-gray-50 border border-gray-200 text-gray-700 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-400"
                />
            )
        },
        {
            id: "action",
            name: "",
            cell: row => (
                <div className="flex flex-col gap-2">
                    {/* PDF actions */}
                    <div className="flex gap-2">
                        <button
                            onClick={() => getPdfDetailFile(row.id)}
                            className={iconBtn}
                        >
                            <i className="fas fa-print text-gray-500" />
                        </button>

                        <button
                            onClick={() => getPdfDetailFile(row.id, true)}
                            className={iconBtn}
                        >
                            <i className="fas fa-paper-plane text-gray-500" />
                        </button>
                    </div>

                    {/* Edit / delete */}
                    <div className="flex gap-2">
                        <button
                            onClick={() => openModalAdd(row)}
                            disabled={!row.can?.update}
                            className={`${iconBtn} ${!row.can?.update ? "opacity-40 cursor-not-allowed" : ""
                                }`}
                        >
                            <i className="fas fa-pen text-gray-500" />
                        </button>

                        <button
                            disabled={!row.can?.delete}
                            className={`${iconBtn} ${!row.can?.delete
                                    ? "opacity-40 cursor-not-allowed"
                                    : "hover:bg-red-50"
                                }`}
                        >
                            <i
                                className={`fas fa-trash ${row.can?.delete ? "text-red-500" : "text-gray-400"
                                    }`}
                            />
                        </button>
                    </div>
                </div>
            )
        }
    ];

    return columns;
};